import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { BotIcon, UserIcon, GitPullRequestIcon } from 'lucide-react';

import helpfulRobot from '@/assets/helpful-robot.webp';

export const Route = createFileRoute('/_authed/_layout/$owner/settings')({
  component: SettingsLayout,
});

function SettingsLayout() {
  const { owner } = Route.useParams();

  return (
    <div className="flex h-full">
      {/* Sidebar */}
      <nav className="w-64">
        <div className="flex h-full flex-col gap-2 py-16 px-4">
          <h3 className="mb-2 px-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">Organization</h3>
          <div className="space-y-1">
            <Link
              to="/$owner/settings/pull-requests"
              params={{ owner }}
              className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors text-muted-foreground hover:bg-slate-200/50 hover:text-foreground"
              activeProps={{
                className:
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors bg-slate-200/50 text-secondary-foreground',
              }}
            >
              <GitPullRequestIcon className="h-4 w-4" />
              Pull Requests
            </Link>

            <Link
              to="/$owner/settings/agents"
              params={{ owner }}
              className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors text-muted-foreground hover:bg-slate-200/50 hover:text-foreground"
              activeProps={{
                className:
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors bg-slate-200/50 text-secondary-foreground',
              }}
            >
              <BotIcon className="h-4 w-4" />
              Review Agent
            </Link>

            {/* <Link
              to="/$owner/settings/members"
              params={{ owner }}
              className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors text-muted-foreground hover:bg-slate-200/50 hover:text-foreground"
              activeProps={{
                className:
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors bg-slate-200/50 text-secondary-foreground',
              }}
            >
              <UserIcon className="h-4 w-4" />
              Members
            </Link> */}
          </div>
        </div>
      </nav>

      {/* Main content area with background image */}
      <div className="flex-1 flex">
        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>

        {/* Desktop Image Section - Only shown on large screens */}
        <div
          className="hidden lg:block lg:w-1/3 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${helpfulRobot})` }}
        />
      </div>
    </div>
  );
}
